module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/79HpdM/tc-custom/Cover.jpg?1680202048160",
      "alt": "This image is the cover for the book Pizzeria Kamikaze, Pizzeria Kamikaze"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pizzeria Kamikaze, Pizzeria Kamikaze\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Presented for the first time in full color, award-winning writer Etgar Keret (The Seven Good Years) and Eisner Award-winning cartoonist Asaf Hanuka’s (The Realist) powerful graphic novel, Pizzeria Kamikaze, is a most unexpected story of love, loss, and escape. Mordy wanted to get away. Now condemned to an afterlife exclusively for all victims of suicide, he still has to attend a crappy job in a place no less crappy than the place he came from. When he discovers that his beloved ex-girlfriend is there too, he embarks on much needed road trip through an absurdist and fantastical landscape to find her.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Etgar Keret, Asaf Hanuka, Dan Jackson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0